"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectType = void 0;
var SelectType;
(function (SelectType) {
    SelectType["BUTTON"] = "button";
})(SelectType = exports.SelectType || (exports.SelectType = {}));
//# sourceMappingURL=SelectProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/SelectProps.js
// module id = 836
// module chunks = 8